export default __webpack_public_path__ + "static/media/pattern-002-2.6964c77e.jpg";